export const precisionLabels = {
  0: "Imprecise",
  1: "Precise (split read support)",
};

export const precisionIndex = {
  precise: 1,
  imprecise: 0,
};
